<template>
  <ul class="menu2-wrapper">
    <li
      class="main_tab"
      v-for="item in ruleCodes"
      :key="item.type"
      :label="item.type"
      @click="handleClick(item)"
      :class="type == item.type ? 'blue' : ''"
    >
      <img v-if="type == item.type" :src="item.unCheckIcon" alt="" />
      <img v-else :src="item.CheckIcon" alt="" />
      <span>{{ item.type }}</span>
    </li>
  </ul>
</template>

<script>
import { useDictList } from "@/api/ApiConfig.js";

export default {
  components: {},
  data() {
    return {
      ruleCodes: [],
      type: "全部实验"
    };
  },
  watch: {},
  created() {
    this.getStudyType();
  },
  activated() {
    this.getStudyType();
  },
  mounted() {},
  methods: {
    // 菜单
    getStudyType() {
      useDictList({
        dictType: 'experType'
      }).then(res => {
        if (res.code === 200) {
          this.ruleCodes = [
            {
              type: "全部实验",
              CheckIcon: require("@/assets/images/icon/all-blue.png"),
              unCheckIcon: require("@/assets/images/icon/all-gray.png")
            },
            ...res.data.map(item => ({
              type: item.dictValue,
              CheckIcon: require("@/assets/images/icon/hot-blue.png"),
              unCheckIcon: require("@/assets/images/icon/hot-gray.png")
            }))
          ]
        }
      });
    },
    // tab点击事件
    handleClick(item) {
      this.type = item.type;
      this.$emit("getData", item.type);
    }
  }
};
</script>
